<template>
	<div class="bodycont">
		 <div class="cont Pub_width">
			 <div class="nav">
				 当前位置:<span @click="goindex()">首页>&nbsp;</span><span style="color: #005b9f;">证书查询</span>
			 </div>
			 <div class="richtext Pub_width">
				 <div class="search Pub_flexrow">
					  <div class="inputcont Pub_flexrow">
						  <div class="inputtext">姓名</div>
						  <input type="text" placeholder="请输入姓名" class="inputdom" v-model="userinput.username"/>
					  </div>
					  <div class="inputcont Pub_flexrow">
						  <div class="inputtext">身份证号</div>
						  <input type="text" placeholder="请输入身份证号" class="inputdom" v-model="userinput.idcard"/>
					  </div>
					  <div class="inputcont Pub_flexrow">
						  <div class="inputtext">准考证号</div>
						  <input type="text" placeholder="请输入准考证号" class="inputdom" v-model="userinput.ucode"/>
					  </div>
					  <div class="searchbtn" @click="search()">搜索</div>
				 </div>
				 
				 <div class="searchend">
					  <div class="searchendcont" v-if="havedata==null" >请先输入查询条件</div>
					   <div class="searchendcont" v-if="havedata==0" >查询无结果</div>
					  <div class="searchtable Pub_flexrowcenter" v-if="havedata==1">
						  <div class="endcard" >
							  <div class="endtitle">理论</div>
							  <div class="endtext">{{chenjidata.lilun}}</div>
						  </div>
						  <div class="endcard">
							  <div class="endtitle">技能</div>
							  <div class="endtext">{{chenjidata.jineng}}</div>
						  </div>
						  <div class="endcard" v-if="chenjidata.dengji=='一级/高级技师'||chenjidata.dengji=='二级/技师'">
							  <div class="endtitle">综合</div>
							  <div class="endtext">{{chenjidata.zonghe}}</div>
						  </div>
						<!--  <div class="endcard">
							  <div class="endtitle">结果</div>
							  <div class="endtext" style="color: dodgerblue;">合格</div>
						  </div> -->
					</div>
				 </div>
			 </div>
		 </div>
	</div>
</template>

<script>
	export default({
		data(){
			return{
				data:[],
				userinput:{
					idcard:"",
					username:"",
					ucode:""
				},
				chenjidata:{},
				havedata:null
			}
		},
		methods:{
			search(){
				let nullnum=0;
				for(let k in this.userinput){
					if(this.userinput[k]==""){
						nullnum+=1
					}
					if(nullnum>=2){
						break;
					}
				}
				if(nullnum>=2){
					this.$Toast({
						 message: "至少输入两项查询条件",
						 position: 'middle',
						 duration: 1000
					})
					return
				}
				this.loaddetail();
			},
			loaddetail(){
				let jsondata = this.userinput
				this.$Get("api.php/cms/chaxun",jsondata,"get").then(res=>{
					this.havedata=res.data.code
					this.chenjidata=res.data.data
				})
		
			},
			goindex(){
				this.$router.push({name:"index_page"})
			},
			goback(){
				this.$router.go(-1)
			}
		},
		created() {
			
		}
	})
</script>

<style scoped="scoped">
	.nav{
		background: white;
		margin-top: 20px;
		margin-bottom: 20px;
		border-radius: 5px;
		width: 100%;
		height: 58px;
		background-color: white;
		border-radius: 5px;
		line-height: 58px;
		padding-left: 20px;
		font-size: 14px;
		cursor: default;
	}
	.nav>span:hover{
		    color: #005b9f;
			text-decoration: underline;
	}
	.richtext{
		background: white;
		border-radius: 5px;
		padding: 20px;
	}
	.search{
		padding-left: 10px;
	}
	.inputtext{
		font-size: 14px;
		padding-right: 5px;
	}
	.inputcont{
		margin-right: 20px;
		align-items: center;
	}
	.inputdom{
		padding: 5px;
		border-radius: 5px;
		border: 1px solid rgb(68,138,202);
		outline: none;
	}
    .searchbtn{
		background:rgb(68,138,202);
		width: 80px;
		white-space: nowrap;
		color: white;
		height: 25px;
		line-height: 25px;
		text-align: center;
		font-size: 14px;
		border-radius: 5px;
		cursor: default;
	}
	.searchend{
		min-height: 500px;
		position: relative;
	}
	.searchendcont{
		color: #6f838d;
		font-size: 14px;
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		text-align: center;
		width: 100%;
	}
	.searchtable{
		border: 1px solid #005b9f;
		width: 1000px;
		margin-left: 10px;
		margin-top: 20px;
		border-radius: 5px;
		justify-content: space-around;
	}
	.endcard{
		height: 100px;
		width: 100%;
		    text-align: center;
	}
	.endtitle{
		padding: 10px 0px 20px 0px;
		border-bottom: 1px solid #f2f2f2;
		font-size: 15px;
		font-weight: bold;
	}
	.endtext{
	   padding: 15px 0px 10px 0px;
	   font-size: 14px;
	}
</style>



// WEBPACK FOOTER //
// src/view/bookdetail.vue